/** Download and decode image URLs so a later <img> can paint from cache. */
export function warmImageCache(urls: readonly string[]): () => void {
  const images = urls.map((src, index) => {
    const image = new Image();
    image.decoding = 'async';
    image.fetchPriority = index === 0 ? 'high' : 'low';
    image.src = src;
    void image.decode().catch(() => undefined);
    return image;
  });

  return () => {
    for (const image of images) {
      image.onload = null;
      image.onerror = null;
      image.src = '';
    }
  };
}
